module.exports = __webpack_public_path__ + "img/2.61eb6a8c.jpg";